// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, of } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../_base/crud';

import { Global } from '../../../../shared/global';
// Models
import { UserMasterModel } from '../_models/userMaster.model';
import { mergeMap } from 'rxjs/operators';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';

const API_CUSTOMERS_URL = Global.BASE_USER_MSTER_ENDPOINT;
const API_URL = Global.BASE_USER_MSTER_BY_COMPANYMID;

@Injectable()
export class UserMasterService {
	loggedCompanyMId: number;

	constructor(private http: HttpClient, private httpUtils: HttpUtilsService,
		private sharedService: ShareddataserviceService) { }

	getLoggedCompanyMId() {
		this.sharedService.companydata.subscribe(data => this.loggedCompanyMId = data[0]["CompanyMId"]);
	}

	// CREATE =>  POST: add a new userMaster to the server
	createUserMaster(userMaster: UserMasterModel): Observable<UserMasterModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<UserMasterModel>(API_CUSTOMERS_URL, userMaster, { headers: httpHeaders });
	}

	uploadImage(imageFile: File, imageName: any): Observable<any> {
		let formData = new FormData();
		formData.append('ImageFile', imageFile, imageFile.name);
		formData.append('imageName', imageName);

		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'multipart/form-data');

		const url = "Global.BASE_UPLOAD_CATEGORY_IMAGE_ENDPOINT";
		// Note: Add headers if needed (tokens/bearer)
		return this.http.post<any>(url, formData, { headers: httpHeaders });
	}

	// READ
	getAllUserMasters(): Observable<UserMasterModel[]> {
		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<UserMasterModel[]>(URL);
	}

	getUserMasterById(UserId: number): Observable<UserMasterModel> {
		return this.http.get<UserMasterModel>(API_CUSTOMERS_URL + `/${UserId}`);
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	// Server should return filtered/sorted result
	findUserMasters(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<QueryResultsModel[]>(URL).pipe(
			mergeMap(res => {
				const result = this.httpUtils.baseFilter(res, queryParams);
				return of(result);
			})
		);
	}

	// UPDATE => PUT: update the userMaster on the server
	updateUserMaster(UserId: number, userMaster: UserMasterModel): Observable<any> {
		const httpHeader = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_CUSTOMERS_URL + UserId, userMaster, { headers: httpHeader });
	}

	// DELETE => delete the userMaster from the server
	deleteUserMaster(UserId: number): Observable<UserMasterModel> {
		const url = `${API_CUSTOMERS_URL}${UserId}`;
		return this.http.delete<UserMasterModel>(url);
	}
}
